export default "__VITE_ASSET__BaxMCAiZ__"